import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';

import MerchantTierTable from './MerchantTierTable';
import TierUpdateButton from './TierUpdateButton';
import useTierList from './useTierList';

export const MerchantTierListTab = () => {
  const {isLoading, fetchList, total, list} = useTierList(
    'merchant-aggregator',
  );

  return (
    <main className="my-5">
      <PermissionsProvider
        permission={AfriexAdminPermission.ReferralTierManage}
      >
        <div className="flex justify-end">
          <TierUpdateButton isMerchant />
        </div>
      </PermissionsProvider>
      <section className="pt-5 md:pt-5">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <MerchantTierTable items={list || []} />
        )}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};
